<template>
  <div>
    <div
      v-if="address"
      class="intent-item pa-1 mb-3"
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      :class="{ edit: isEdit }"
    >
      <v-layout v-if="!isEdit" wrap>
        <v-flex xs10 align-items-center> {{ addressInfo.name }} ({{ addressInfo.tel }}) </v-flex>
        <v-flex xs2 align-items-center>
          <v-btn
            v-if="!isEdit"
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="isEdit = true"
          >
            <em class="fas fa-pencil-alt" />
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div class="mb-2">
            {{ formattedAddress }}
          </div>
          <div class="caption">Latitude: {{ address.address_lat || '-' }}</div>
          <div class="caption">Longitude: {{ address.address_long || '-' }}</div>
          <div v-if="address.address_lat && address.address_long">
            <div class="caption mt-2">Google map link:</div>
            <a
              :href="`https://maps.google.com?q=${address.address_lat},${address.address_long}`"
              target="_blank"
              style="word-break: break-word"
            >
              https://maps.google.com?q={{ `${address.address_lat},${address.address_long}` }}
            </a>
          </div>
        </v-flex>
      </v-layout>

      <div v-if="isEdit" class="py-2">
        <div>
          <v-layout wrap>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('name') }">
                <div>{{ $t('Name') }}</div>
                <input
                  v-model="input.address.name"
                  v-validate="'required'"
                  type="text"
                  name="name"
                  :data-vv-as="$t('Name')"
                />

                <span v-if="errors.has('name')" class="text-error">{{ errors.first('name') }}</span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('tel') }">
                <div>{{ $t('phone_number') }}</div>
                <input
                  v-model="input.address.tel"
                  v-validate="'required'"
                  type="text"
                  name="tel"
                  :data-vv-as="$t('phone_number')"
                />

                <span v-if="errors.has('tel')" class="text-error">{{ errors.first('tel') }}</span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('zipcode') }">
                <div>{{ $t('Postcode') }}</div>
                <thai-address-input
                  v-model="input.address.zipcode"
                  type="zipcode"
                  :placeholder="$t('Postcode')"
                  @select="onSelectAddress"
                />
                <input
                  v-model="input.address.zipcode"
                  v-validate="'required'"
                  type="hidden"
                  name="zipcode"
                  :data-vv-as="$t('Postcode')"
                />

                <span v-if="errors.has('zipcode')" class="text-error">{{
                  errors.first('zipcode')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('province') }">
                <div>
                  <label for="province" class="caption"
                    >{{ $t('Province') }} <span class="red--text">*</span></label
                  >
                </div>
                <thai-address-input
                  v-model="input.address.province"
                  type="province"
                  :placeholder="$t('Province')"
                  @select="onSelectAddress"
                />
                <input
                  v-model="input.address.province"
                  v-validate="'required'"
                  type="hidden"
                  name="province"
                  :data-vv-as="$t('Province')"
                />

                <span v-if="errors.has('province')" class="text-error">{{
                  errors.first('province')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('district') }">
                <div>
                  <label for="district" class="caption"
                    >{{ $t('District') }} <span class="red--text">*</span></label
                  >
                </div>
                <thai-address-input
                  v-model="input.address.district"
                  type="amphoe"
                  :placeholder="$t('District')"
                  @select="onSelectAddress"
                />
                <input
                  v-model="input.address.district"
                  v-validate="'required'"
                  type="hidden"
                  name="district"
                  :data-vv-as="$t('District')"
                />
                <span v-if="errors.has('district')" class="text-error">{{
                  errors.first('district')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('sub_district') }">
                <div>
                  <label for="sub_district" class="caption"
                    >{{ $t('Subdistrict') }} <span class="red--text">*</span></label
                  >
                </div>
                <thai-address-input
                  v-model="input.address.sub_district"
                  type="district"
                  :placeholder="$t('Subdistrict')"
                  @select="onSelectAddress"
                />
                <input
                  v-model="input.address.sub_district"
                  v-validate="'required'"
                  type="hidden"
                  name="sub_district"
                  :data-vv-as="$t('Subdistrict')"
                />

                <span v-if="errors.has('sub_district')" class="text-error">{{
                  errors.first('sub_district')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm12>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('address') }">
                <div>
                  <label for="address" class="caption"
                    >{{ $t('Address') }} <span class="red--text">*</span></label
                  >
                </div>
                <textarea
                  id="address"
                  v-model="input.address.address"
                  v-validate="'required'"
                  name="address"
                  style="width: 100%; min-height: 100px"
                  :data-vv-as="$t('Address')"
                  class="form-control"
                  :placeholder="$t('Address')"
                ></textarea>
                <span v-show="errors.has('address')" class="text-error">
                  {{ errors.first('address') }}
                </span>
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control">
                <div>Latitude</div>
                <input v-model="input.address_lat" type="text" name="latitude" />
              </div>
            </v-flex>
            <v-flex xs12 class="px-1">
              <div class="form-control">
                <div>Longitude</div>
                <input v-model="input.address_long" type="text" name="Longitude" />
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" :loading="saveLoading" @click="handleSave">{{
            $t('Save')
          }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tremendousApi from '@/api/tremendous'
import { mapGetters } from 'vuex'
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'

export default {
  components: { ThaiAddressInput },
  props: {
    address: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      saveLoading: false,
      isEdit: false,
      input: {
        address: {
          name: '',
          tel: '',
          address: '',
          sub_district: '',
          district: '',
          province: '',
          zipcode: ''
        },
        address_lat: '',
        address_long: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    addressInfo() {
      return this.address.address
    },
    formattedAddress() {
      const tempAddress = this.address.address
      if (tempAddress) {
        const shippingAddress = tempAddress.address

        // eslint-disable-next-line no-useless-escape
        let combineAddress = shippingAddress ? shippingAddress.replace(/\<|\>/g, '') : ''

        if (
          tempAddress.sub_district &&
          tempAddress.district &&
          tempAddress.province &&
          tempAddress.zipcode
        ) {
          const inBangkok = tempAddress.province == 'กรุงเทพมหานคร'
          combineAddress = combineAddress.replace(tempAddress.zipcode, '')
          combineAddress =
            combineAddress +
            ' , ' +
            [
              (inBangkok ? 'แขวง' : 'ตำบล') + tempAddress.sub_district.replace(/,/g, ''),
              (inBangkok ? 'เขต' : 'อำเภอ') + tempAddress.district.replace(/,/g, ''),
              'จังหวัด' + tempAddress.province.replace(/,/g, ''),
              tempAddress.zipcode.replace(/,/g, '')
            ].join(' , ')
        }

        return combineAddress
      }
      return null
    }
  },

  async mounted() {
    this.initForm()
  },
  methods: {
    initForm() {
      try {
        if (!this.address) return

        const tempAddress = this.address
        const tempAddressInfo = tempAddress.address

        this.input = {
          address: {
            name: tempAddressInfo.name,
            tel: tempAddressInfo.tel,
            address: tempAddressInfo.address,
            sub_district: tempAddressInfo.sub_district,
            district: tempAddressInfo.district,
            province: tempAddressInfo.province,
            zipcode: tempAddressInfo.zipcode
          },
          address_lat: tempAddress.address_lat,
          address_long: tempAddress.address_long
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleSave() {
      const vm = this
      try {
        vm.saveLoading = true

        const tempAddress = vm.address

        const data = {
          page_id: tempAddress.page_id,
          id: tempAddress.id,
          user_id: tempAddress.user_id,
          address: {
            name: vm.input.address.name,
            province: vm.input.address.province,
            zipcode: vm.input.address.zipcode,
            district: vm.input.address.district,
            sub_district: vm.input.address.sub_district,
            address: vm.input.address.address,
            tel: vm.input.address.tel
          },
          main_address: tempAddress.main_address,
          address_lat: vm.input.address_lat,
          address_long: vm.input.address_long
        }

        const response = await tremendousApi.putUpdateShippingAddress({ data })

        if (response && response.status === 204) {
          vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })

          vm.isEdit = false
          vm.$emit('onRefetch')
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.saveLoading = false
      }
    },
    handleCancel() {
      this.isEdit = false
    },
    onSelectAddress(address) {
      this.input.address.sub_district = address.district
      this.input.address.district = address.amphoe
      this.input.address.province = address.province
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/ShippingAddressItem.vue